export class PeriodDto {
  month: number;
  year: number;
}
